import {
  createBrowserRouter,
} from "react-router-dom";
import Login from "./Components/Login";
import ProtectedRoute from "./Components/Shared/ProtectedRoute/ProtectedRoute";
import Home from "./Components/Home";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import Register from "./Components/Register/Register";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import Billing from "./Components/Billing";
import Agents from "./Components/Agents";
import KnowledgeDatabase from "./Components/KnowledgeDatabase/KnowledgeDatabasePage";
import KnowledgeDatabaseEntries from "./Components/KnowledgeDatabase/KnowledgeDatabaseDetail/KnowledgeDatabaseDetail";
import UserProfile from "./Components/Profile/Profile";
import MessageDisplay from "./Components/Messages";
import ChangePassword from "./Components/Profile/ChangePassword/ChangePassword";
import UserList from "./Components/Users/Users";
import Transactions from "./Components/Transactions";
import EmailVerificationPage from "./Components/EmailVerification/EmailVerification";
import PaymentStatus from "./Components/PaymentStatus/PaymentStatus";
import Settings from "./Components/Settings/Settings";
import AcceptTerms from "./Components/AcceptTerms/AcceptTerms";
import NotFound from "./Components/NotFound/NotFound";

import { basename } from "./Constants/env"
const Router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute component={Home} exact />,
  },
  {
    path: "/users",
    element: <ProtectedRoute component={UserList} exact />,
  },
  {
    path: "/billing",
    element: <ProtectedRoute component={Billing} exact />,
  },
  {
    path: "/transactions",
    element: <ProtectedRoute component={Transactions} exact />,
  },
  {
    path: "/agents",
    element: <ProtectedRoute component={Agents} exact />,
  },
  {
    path: "/messages",
    element: <ProtectedRoute component={MessageDisplay} exact />,
  },
  {
    path: "/knowledge-base",
    element: <ProtectedRoute component={KnowledgeDatabase} exact />,
  },
  {
    path: "/knowledge-base/:id",
    element: <ProtectedRoute component={KnowledgeDatabaseEntries} exact />,
  },
  {
    path: "/profile",
    element: <ProtectedRoute component={UserProfile} exact />,
  },
  {
    path: "/change-password",
    element: <ProtectedRoute component={ChangePassword} exact />,
  },
  {
    path: "/settings",
    element: <ProtectedRoute component={Settings} exact />,
  },
  {
    path: "/payments",
    element: <ProtectedRoute component={PaymentStatus} useLayout={false} />,
  },
  {
    path: "/accept-terms",
    Component: AcceptTerms,
  },
  {
    path: "/404",
    Component: NotFound,
  },
  {
    path: "login",
    Component: Login,
  },
  {
    path: "register",
    Component: Register,
  },
  {
    path: "forgot-password",
    Component: ForgotPassword,
  },
  {
    path: "reset-password/:token",
    Component: ResetPassword,
  },
  {
    path: "verify-email/:token",
    Component: EmailVerificationPage,
  },
  {
    path: "*",
    Component: NotFound,
  },
],
  { basename }
);

export default Router;
